export const getIconName = (fileType: string) => {
  switch (fileType) {
    case 'xlsx':
    case 'xls':
      return 'file_excel'
    case 'docx':
    case 'doc':
      return 'file_word'
    case 'ppt':
      return 'file_ppt'
    case 'pdf':
      return 'file_pdf2'
    case 'jpg':
    case 'png':
    case 'gif':
    case 'svg':
    case 'jpeg':
      return 'file_image'
    case 'mpeg':
    case 'wav':
      return 'file_music'
    case 'mp4':
    case 'quicktime':
      return 'file_video'
    case 'zip':
      return 'file_zip'
    default:
      return 'file'
  }
}
